import request from '../request'
export async function GetInspectionRate(options?:any){
    return request('api/InspectionRate/Get',{
        method:"GET",
        ...(options || {})
    })
}